import { Button, Divider, InputNumber, Row, Space } from 'antd';
import { useCallback, useContext, useMemo } from 'react';

import { useContentWidth, useWindowSize } from '@app/hooks';
import {
  CHF_MAX_COUNT_RECORDS,
  CHF_MIN_COUNT_RECORDS,
  CHF_VISITS_FILTER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { hideFilterBlock } from '@pages/Clients/ClientsList/utils';

const PADDING_SIZE = 32;
const WIDTH_BETWEEN_INPUTS = 12;
const BREAKPOINT_WIDE = 950;
const BREAKPOINT_MEDIUM = 792;
const BASE_WIDTH_WIDE = 100;
const WIDTH_ADJUSTMENT = 18;

export const VisitsRecordsCount = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { innerWidth } = useWindowSize();
  const { contentWidth } = useContentWidth();
  const {
    filters,
    setUpServerDataChunk,
    handleDisabling,
    onChangeFiltersHandler,
  } = useContext(ClientFiltersContext);
  const calculateWidth = (innerWidth: number, contentWidth: number) => {
    if (innerWidth > BREAKPOINT_WIDE) {
      return BASE_WIDTH_WIDE;
    } else if (
      innerWidth > BREAKPOINT_MEDIUM &&
      innerWidth <= BREAKPOINT_WIDE
    ) {
      return (contentWidth - PADDING_SIZE - WIDTH_BETWEEN_INPUTS) / 4;
    } else {
      return (
        (contentWidth - PADDING_SIZE - WIDTH_BETWEEN_INPUTS) / 2 +
        WIDTH_ADJUSTMENT
      );
    }
  };

  const useMemoizedInputStyles = (innerWidth: number, contentWidth: number) => {
    return useMemo(() => {
      const width = calculateWidth(innerWidth, contentWidth);
      return { width: `${width}px` };
    }, [innerWidth, contentWidth]);
  };
  const memoizedInputStyles = useMemoizedInputStyles(innerWidth, contentWidth);

  const { MinCountRecords, MaxCountRecords } = useMemo(
    () => filters.VisitsFilter?.[filterGroupIndex]?.Values?.[0],
    [filters, filterGroupIndex]
  );

  const onChangeHandler = useCallback(
    (type: 'MinCountRecords' | 'MaxCountRecords') => (value: number | null) => {
      onChangeFiltersHandler('VisitsFilter', filterGroupIndex, type, value);
    },
    [filterGroupIndex, onChangeFiltersHandler]
  );

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === '-' || event.key === '+') {
        event.preventDefault();
      }
    },
    []
  );
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Space>
        {/* TODO: попробовать гарантировать ширину половины блока через гриды */}
        <InputNumber
          controls={false}
          addonBefore="от"
          style={memoizedInputStyles}
          type="number"
          value={MinCountRecords}
          onChange={onChangeHandler('MinCountRecords')}
          onKeyDown={onKeyDown}
        />
        <InputNumber
          controls={false}
          addonBefore="до"
          style={memoizedInputStyles}
          type="number"
          value={MaxCountRecords}
          onChange={onChangeHandler('MaxCountRecords')}
          onKeyDown={onKeyDown}
        />
      </Space>
      <Divider style={{ marginTop: '8px', marginBottom: '12px' }} />
      <Row justify="end">
        <Button
          type="primary"
          size="small"
          disabled={handleDisabling(
            CHF_VISITS_FILTER,
            CHF_MIN_COUNT_RECORDS,
            true,
            CHF_MAX_COUNT_RECORDS,
            filterGroupIndex
          )}
          onClick={() => {
            setUpServerDataChunk(
              CHF_VISITS_FILTER,
              CHF_MIN_COUNT_RECORDS,
              true,
              CHF_MAX_COUNT_RECORDS,
              filterGroupIndex
            );

            hideFilterBlock(
              '.visits-records-count-label',
              innerWidth,
              filterGroupIndex
            );
          }}
        >
          Выбрать
        </Button>
      </Row>
    </div>
  );
};
